import { render } from "./Events.vue?vue&type=template&id=3fd10f4e"
import script from "./Events.vue?vue&type=script&setup=true&lang=js"
export * from "./Events.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Member/Events.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fd10f4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fd10f4e', __exports__)) {
    api.reload('3fd10f4e', __exports__)
  }
  
  module.hot.accept("./Events.vue?vue&type=template&id=3fd10f4e", () => {
    api.rerender('3fd10f4e', render)
  })

}


export default __exports__